import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { PublicSectionLayoutComponent } from './public.section.layout';
import { LoginComponent } from './login.component';
import { ErrorComponent } from './error/error/error.component';
import { I18NextModule } from 'angular-i18next';

/**
 * Rutas del modulo
 */
const ROUTES = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'error', component: ErrorComponent },
];

/**
 * Modulo para la seccion publica
 */
@NgModule({
  declarations: [
    PublicSectionLayoutComponent,
    LoginComponent,
    ErrorComponent
  ],
  imports: [
    FormsModule,
    CommonModule,
    RouterModule.forChild([{
      path: '',
      component: PublicSectionLayoutComponent,
      children: ROUTES
    }]),
    I18NextModule
  ],
})

export class PublicSectionModule { }



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/public/public.section.module.ts